import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import { Tab } from "@mui/material";
import { Group } from "./Group";
import { Panel } from "./Panel";
import { useTab } from "./tabContext";
import { Tabs } from "./Tabs";
const StyledTab = styled(Tab)(({ style, size, disabled }) => ({
    padding: "0 !important",
    minHeight: (size === "small" && "30px") || "34px",
    height: "100%",
    display: "flex",
    justifyContent: "start",
    borderBottom: `1px solid ${palette.grey025}`,
    color: disabled ? `${palette.grey030} !important` : palette.grey060,
    ...typography[(size === "small" && "Content.Subtitle04") || "Content.Title04"],
    ...style,
}));
export const GrTab = ({ children, ...props }) => {
    const { color, size } = useTab();
    return _jsx(StyledTab, { ...props, label: children, color: color, disableRipple: true, size: size });
};
GrTab.Group = Group;
GrTab.Tabs = Tabs;
GrTab.Panel = Panel;
//# sourceMappingURL=GrTab.js.map